import { render, staticRenderFns } from "./HospitalsModule.vue?vue&type=template&id=b9285004&scoped=true&"
import script from "./HospitalsModule.vue?vue&type=script&lang=js&"
export * from "./HospitalsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9285004",
  null
  
)

export default component.exports